<template>
  <div class="d-flex align-center">
    <p class="mr-2 mb-0">Import Attendance</p>
    <input type="file" ref="fileInput" accept=".dat" />
    <v-btn small color="primary" :loading="loading" @click="uploadFile"
      >Upload File</v-btn
    >
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    uploadFile() {
      // Validate file is selected
      if (!this.$refs.fileInput.files || !this.$refs.fileInput.files[0]) {
        alert("Please select a .dat file first.");
        return;
      }

      const file = this.$refs.fileInput.files[0];

      // Validate file extension
      if (!file.name.toLowerCase().endsWith(".dat")) {
        alert("Invalid file type. Please select a .dat file.");
        return;
      }

      // Validate file is not empty
      if (file.size === 0) {
        alert("The selected file is empty.");
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post("/import_attendances", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          const data = res.data;
          let message = data.message || "Import completed.";

          if (data.skipped > 0) {
            message += `\n${data.skipped} records were skipped.`;
          }

          if (data.unmatched_employee_ids && data.unmatched_employee_ids.length > 0) {
            message += `\nUnmatched employee IDs: ${data.unmatched_employee_ids.join(", ")}`;
          }

          if (data.errors && data.errors.length > 0) {
            message += `\n\nFirst errors:\n${data.errors.slice(0, 5).join("\n")}`;
          }

          alert(message);
          this.loading = false;
          this.$refs.fileInput.value = "";
        })
        .catch((e) => {
          let errorMsg = "Upload failed.";
          if (e.response && e.response.data && e.response.data.error) {
            errorMsg = e.response.data.error;
          } else if (e.message) {
            errorMsg = e.message;
          }
          alert(errorMsg);
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
